import Employee from '../interfaces/Employee';

export const INITIAL_VALUES_EMPLOEE: Employee = {
    Nome: '',
    Email: '',
    UserAD: '',
}